import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(fileId) {
  return `${API}/archivos/${fileId}/download`;
}

// Miniatura para vistas de lista/grid (Colecciones, Kanban, Tablero). El original se usa en lightbox/preview.
export function thumbUrl(fileId) {
  return `${API}/archivos/${fileId}/thumb`;
}

export default api;
